import React from 'react';
import './services.css';

const Services = () => (
    <div>
      Services
    </div>
);

export default Services